export interface SelectionConnectorNode {
  id: string;
  position: { x: number; y: number };
  width: number;
  height: number;
}

export interface SelectionConnectorViewport {
  x: number;
  y: number;
  zoom: number;
}

export interface SelectionConnectorLayout {
  bounds: { left: number; top: number; width: number; height: number };
  outlet: { x: number; y: number };
  label: string;
}

const padding = 12;

export function selectionConnectorLayout({
  nodes,
  viewport
}: {
  nodes: readonly SelectionConnectorNode[];
  viewport: SelectionConnectorViewport;
}): SelectionConnectorLayout | undefined {
  if (nodes.length === 0) return undefined;
  const left = Math.min(...nodes.map((node) => node.position.x)) - padding;
  const top = Math.min(...nodes.map((node) => node.position.y)) - padding;
  const right = Math.max(...nodes.map((node) => node.position.x + node.width)) + padding;
  const bottom = Math.max(...nodes.map((node) => node.position.y + node.height)) + padding;
  const screenLeft = left * viewport.zoom + viewport.x;
  const screenTop = top * viewport.zoom + viewport.y;
  const width = (right - left) * viewport.zoom;
  const height = (bottom - top) * viewport.zoom;
  return {
    bounds: { left: screenLeft, top: screenTop, width, height },
    outlet: { x: screenLeft + width, y: screenTop + height / 2 },
    label: `已选 ${nodes.length} 个输入`
  };
}
